
import Colors from '@constants/Colors';
import styled from '@emotion/styled';
import { alpha, Box, FormGroup, FormLabel, FormControlLabel as MuiFormControlLabel, Radio, RadioGroup, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import { Roles } from '@utils/roleUtils';
import { Controller } from 'react-hook-form';
import { BaseInputProps } from './InputFieldControlled/InputText.types';
import Icons from './Icons';

const FormControlLabel = styled(MuiFormControlLabel)`
    .MuiFormControlLabel-label {
        font-size: 14px;
        color: ${Colors.NEUTRAL_BLACK};
    }
    .MuiButtonBase-root {
        // padding: 0;
    }
    // radio
    .MuiRadio-root {
        padding: 0 9px;
    }
`;

const labels = {
    [Roles.ADMIN_PRO]: 'Administrateur',
    [Roles.MEMBER_PRO]: 'Membre',
    [Roles.ACCOUNTANT_PRO]: 'Comptable',
};

const RoleDescription = {
    ADMIN_PRO: `Le rôle d'administrateur vous permet de gérer les processus de recrutement.`,
    MEMBER_PRO: `Le rôle de membre vous permet de gérer les processus de recrutement.`,
    ACCOUNTANT_PRO: `Le rôle de comptable vous permet de gérer les processus de recrutement.`,
};

function InputRole(props: BaseInputProps & { credits?: Record<string, any> }) {
    const isMobile = useMediaQuery('(max-width:600px)');
    return (
        <FormGroup>
            <Controller
                name={props.name}
                control={props.control}
                rules={{
                    required: props.required,
                }}
                defaultValue={props.defaultValue}
                render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
                    return (
                        <Box mb={1}>
                            <TextField
                                ref={ref}
                                style={{ opacity: 0, width: 1, height: 1 }}
                            />
                            <FormLabel error={!!error}>
                                {props.label}
                            </FormLabel>
                            {props.viewOnly ? (
                                <FormLabel error={!!error}>
                                    {value}
                                </FormLabel>
                            ) : (
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue={Roles.ADMIN_PRO}
                                    onChange={e => onChange(e.target.value)}
                                    style={{
                                        flexDirection: 'row',
                                        display: 'flex',
                                        justifyContent: isMobile ? 'space-between' : 'flex-start',
                                        gap: !isMobile ? 16 : 0,
                                    }}
                                    name="radio-buttons-group">
                                    <FormControlLabel
                                        style={{ marginRight: 0 }}
                                        value={Roles.ADMIN_PRO}
                                        control={
                                            <Radio
                                                style={props.textStyle}
                                                name={props.name}
                                                checked={value === Roles.ADMIN_PRO}
                                                disabled={
                                                    (props.credits[Roles.ADMIN_PRO]?.configuration?.maximum !== -1 &&
                                                        props.credits[Roles.ADMIN_PRO]?.configuration?.used >=
                                                        props.credits[Roles.ADMIN_PRO]?.configuration?.maximum) ||
                                                    props.disabled
                                                }
                                            />
                                        }
                                        label={
                                            <Stack>
                                                <FormLabel sx={{ mb: 0 }}>
                                                    {labels[Roles.ADMIN_PRO]}
                                                </FormLabel>
                                                <Typography component="span" color="text.secondary" variant="caption">
                                                    (crédits {props.credits[Roles.ADMIN_PRO]?.configuration?.used}/
                                                    {props.credits[Roles.ADMIN_PRO]?.configuration?.maximum === -1
                                                        ? '∞'
                                                        : props.credits[Roles.ADMIN_PRO]?.configuration?.maximum}
                                                    )
                                                </Typography>
                                            </Stack>
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ marginRight: 0 }}
                                        value={Roles.MEMBER_PRO}
                                        control={
                                            <Radio
                                                style={props.textStyle}
                                                name={props.name}
                                                checked={value === Roles.MEMBER_PRO}
                                                disabled={
                                                    (props.credits[Roles.MEMBER_PRO]?.configuration?.maximum !== -1 &&
                                                        props.credits[Roles.MEMBER_PRO]?.configuration?.used >=
                                                        props.credits[Roles.MEMBER_PRO]?.configuration?.maximum) ||
                                                    props.disabled
                                                }
                                            />
                                        }
                                        label={
                                            <Stack>
                                                <FormLabel sx={{ mb: 0 }}>
                                                    {labels[Roles.MEMBER_PRO]}
                                                </FormLabel>
                                                <Typography component="span" color="text.secondary" variant="caption">
                                                    (crédits {props.credits[Roles.MEMBER_PRO]?.configuration?.used}/
                                                    {props.credits[Roles.MEMBER_PRO]?.configuration?.maximum === -1
                                                        ? '∞'
                                                        : props.credits[Roles.MEMBER_PRO]?.configuration?.maximum}
                                                    )
                                                </Typography>
                                            </Stack>
                                                
                                        }
                                    />
                                    <FormControlLabel
                                        style={{ marginRight: 0 }}
                                        value={Roles.ACCOUNTANT_PRO}
                                        control={
                                            <Radio
                                                style={props.textStyle}
                                                name={props.name}
                                                checked={value === Roles.ACCOUNTANT_PRO}
                                                disabled={
                                                    (props.credits[Roles.ACCOUNTANT_PRO]?.configuration?.maximum !== -1 &&
                                                        props.credits[Roles.ACCOUNTANT_PRO]?.configuration?.used >=
                                                        props.credits[Roles.ACCOUNTANT_PRO]?.configuration?.maximum) ||
                                                    props.disabled
                                                }
                                            />
                                        }
                                        label={
                                            <Stack>
                                                <FormLabel sx={{ mb: 0 }}>
                                                    {labels[Roles.ACCOUNTANT_PRO]}
                                                </FormLabel>
                                                <Typography component="span" color="text.secondary" variant="caption">
                                                    (crédits {props.credits[Roles.ACCOUNTANT_PRO]?.configuration?.used}/
                                                    {props.credits[Roles.ACCOUNTANT_PRO]?.configuration?.maximum === -1
                                                        ? '∞'
                                                        : props.credits[Roles.ACCOUNTANT_PRO]?.configuration?.maximum}
                                                    )
                                                </Typography>
                                            </Stack>
                                                
                                        }
                                    />
                                </RadioGroup>
                            )}

                            {value && (
                                <Stack
                                    sx={{
                                        marginTop: '8px',
                                        borderRadius: '8px',
                                        background: theme => alpha(theme.palette.primary.main, 0.1),
                                        border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                                        color: theme => theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
                                        fontFamily: 'Plus Jakarta Sans',
                                        fontSize: 14,
                                        padding: '8px 16px',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}>
                                    <Icons name="info" size={16} style={{ marginRight: '8px' }} />
                                    {RoleDescription[value]}
                                </Stack>
                            )}
                        </Box>
                    );
                }}
            />
        </FormGroup>
    );
}

export default InputRole;
